module.exports = __webpack_public_path__ + "fonts/Montserrat-LightItalic.d79f80a.ttf";